import { Popover } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { RequireLoginContent } from '@/features/hospital/HospitalSearchFilters/PopoverContentContainer/RequireLoginContent';
import { useState } from 'react';

export const PublicCalendarFilterField = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
    event.preventDefault();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <MuiTextField
        fullWidth
        onClick={handleClick}
        size="small"
        sx={{
          backgroundColor: '#FAFAFA',
          borderColor: 'tomato',
          '& .Mui-disabled': {
            WebkitTextFillColor: '#000',
          },
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#0000003b',
              borderWidth: '1px',
            },
          },
          '& .MuiInputBase-input': {
            cursor: 'pointer',
          },
        }}
        InputProps={{
          startAdornment: (
            <LockIcon
              sx={{
                color: '#FFB300',
                width: '20px',
                marginRight: '8px',
              }}
            />
          ),
          readOnly: true,
        }}
        placeholder="日時を選ぶ"
      />
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <RequireLoginContent />
      </Popover>
    </>
  );
};
